import { Inject, Injectable } from "@angular/core";
import { Stage } from "../../shared/constants";
import { ProductStage } from "../../shared/constants";
import { ENV_FILE_TOKEN } from "../constants/env-token";
import { EnvConfig } from "../models/env-config";
import { EnvName } from "../constants/env-name";

@Injectable({
  providedIn: "root",
})
export class EnvironmentStageService {
  #stage: Stage = Stage.LOCAL;
  #productStage: ProductStage = ProductStage.GAST;

  constructor(@Inject(ENV_FILE_TOKEN) private environment: EnvConfig) {
    this.#setStages(this.environment.envName);
  }

  /**
    Returns true if env name NOT contains of product specific strings: (dtz,inl)
    @returns {@link boolean}
  */
  isGAST(): boolean {
    return this.#productStage === ProductStage.GAST;
  }

  /**
    Returns true if env name contains DTZ specific string (appr-dtz)
    @returns {@link boolean}
  */
  isDTZ(): boolean {
    return this.#productStage === ProductStage.DTZ;
  }

  /**
    Returns true if env name contains INL specific string (appr-inl)
    @returns {@link boolean}
  */
  isINL(): boolean {
    return this.#productStage === ProductStage.INL;
  }

  /**
    Returns true if env name NOT contains stage specific strings: (dev, appr, apprex, prod)
    @returns {@link boolean}
  */
  isLocal(): boolean {
    return this.#stage === Stage.LOCAL;
  }

  /**
    Returns true if env name contains DEV specific string (dev)
    @returns {@link boolean}
  */
  isDev(): boolean {
    return this.#stage === Stage.DEV;
  }

  /**
    Returns true if env name contains APPR specific string (appr)
    @returns {@link boolean}
  */
  isAppr(): boolean {
    return this.#stage === Stage.APPR;
  }

  /**
    Returns true if env name contains APPREX specific string (apprex)
   @returns {@link boolean}
  */
  isApprex(): boolean {
    return this.#stage === Stage.APPREX;
  }

  /**
    Returns true if env name contains PROD specific string (prod)
   @returns {@link boolean}
  */
  isProd(): boolean {
    return this.#stage === Stage.PROD;
  }

  #setStages(envName: EnvName): void {
    const lowerCaseEnvName = envName.toLocaleLowerCase();
    this.#setStage(lowerCaseEnvName);
    this.#setProductStage(lowerCaseEnvName);
  }

  #setStage(envName: string): void {
    if (envName.includes(Stage.DEV.toLocaleLowerCase())) {
      this.#stage = Stage.DEV;
    }
    if (envName.includes(Stage.APPR.toLocaleLowerCase())) {
      this.#stage = Stage.APPR;
    }
    if (envName.includes(Stage.APPREX.toLocaleLowerCase())) {
      this.#stage = Stage.APPREX;
    }
    if (envName.includes(Stage.PROD.toLocaleLowerCase())) {
      this.#stage = Stage.PROD;
    }
  }

  #setProductStage(envName: string): void {
    if (envName.includes(ProductStage.DTZ.toLocaleLowerCase())) {
      this.#productStage = ProductStage.DTZ;
    }
    if (envName.includes(ProductStage.INL.toLocaleLowerCase())) {
      this.#productStage = ProductStage.INL;
    }
  }
}
